import { Icon, IconProps } from '@chakra-ui/react'

const ClipboardCopy = ({ ...rest }: IconProps) => {
  return (
    <Icon
      width="16px"
      height="16px"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g clipPath="url(#clip0_5752_33560)">
        <path
          d="M11.25 4.25V1.75H1.75V11.25H4.25M4.75 4.75V14.25H14.25V4.75H4.75Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_5752_33560">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </Icon>
  )
}

export default ClipboardCopy
